type Args = {
  originalSize: { width: number; height: number };
  size: { width?: number; height?: number };
};

export function getFilestackImageSizeFromRatio({ originalSize, size }: Args): {
  width: number;
  height: number;
} {
  if (typeof size.width === 'number') {
    const multiplier = size.width / originalSize.width;
    return {
      width: size.width,
      height: Math.floor(originalSize.height * multiplier),
    };
  }

  if (typeof size.height === 'number') {
    const multiplier = size.height / originalSize.height;
    return {
      width: Math.floor(originalSize.width * multiplier),
      height: size.height,
    };
  }

  return { width: originalSize.width, height: originalSize.height };
}
